import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class LanguageLookupService {
  public getLanguagesPreferences(): Observable<{ label: string; value: Dtos.Language }[]> {
    const languagePreferences = Object.entries(Dtos.AvailableLanguages).map<{
      label: string;
      value: Dtos.Language;
    }>(([value, label]) => ({
      label,
      value: value as Dtos.Language,
    }));

    return of<{ label: string; value: Dtos.Language }[]>(languagePreferences);
  }

  public getAvailableLanguagesForTranslation(): Observable<{ label: string; value: Dtos.Language }[]> {
    const languagePreferences = Object.entries(Dtos.AvailableLanguages)
      .map<{ label: string; value: Dtos.Language }>(([value, label]) => ({
        label,
        value: value as Dtos.Language,
      }))
      .filter(language => ['en', 'ru', 'kk'].includes(language.value));

    return of<{ label: string; value: Dtos.Language }[]>(languagePreferences);
  }
}
